import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './components/AdminSidebar';
import type { AdminSession } from './hooks/useAdminAuth';

interface Props {
  session: AdminSession;
  onLogout: () => void;
}

export default function AdminLayout({ session, onLogout }: Props) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen bg-[#f4f6f9]">
      <AdminSidebar
        session={session}
        onLogout={onLogout}
        collapsed={collapsed}
        onToggle={() => setCollapsed((v) => !v)}
      />
      <main className="flex-1 min-w-0 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}